var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 86 85",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.686 75.948C24.131 75.947 9.091 60.971 9.091 42.499c0-18.473 15.04-33.449 33.595-33.449 18.553 0 33.594 14.976 33.594 33.449S61.239 75.948 42.686 75.948m0-75.948C19.112 0 0 19.027 0 42.5c0 23.471 19.112 42.499 42.686 42.499s42.685-19.028 42.685-42.5S66.259 0 42.685 0",
    fill: "#1f355e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.28 42.5c0 18.645-15.041 33.761-33.594 33.761-18.555 0-33.595-15.116-33.595-33.761 0-18.646 15.04-33.762 33.595-33.762 18.553 0 33.594 15.116 33.594 33.762",
    fill: "#7FBD5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4 38.403c0 2.686-2.166 4.862-4.838 4.862-2.673 0-4.839-2.175-4.839-4.862 0-2.686 2.166-4.862 4.839-4.862 2.672 0 4.838 2.176 4.838 4.862M28.771 38.403c0 2.686-2.165 4.862-4.839 4.862-2.673 0-4.837-2.175-4.837-4.862 0-2.686 2.164-4.862 4.837-4.862 2.664 0 4.839 2.176 4.839 4.862",
    fill: "#1f355e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.086 49.208s16.3 17.016 37.476 0",
    fill: "none",
    stroke: "#1f355e",
    strokeWidth: 1.19
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace22);
export default __webpack_public_path__ + "static/media/face22.d7cf66c2ba295d3e7f2b8ccd64bedfa8.svg";
export { ForwardRef as ReactComponent };